function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import { InternalLink } from './internalLink';
import { Constants } from '../utils/constants';
import { focusElement } from '../utils/appUtils';
import { getEntityRegistration } from '../utils/entityRegistration';
import { getNpsModule } from '@appsource/utils/nps';
const classNames = require('classnames-minimal');
class PaginationControl extends SpzaComponent {
    getPageNavigationArray() {
        const pageArray = [];
        const pageSpan = 4;
        if (this.props.maxPages > 1) {
            let min = this.props.galleryPage - 2;
            if (min < 1) {
                min = 1;
            }
            let max = min + pageSpan; // there should only be a total of pageSpan + 1 'pages' visible
            if (max > this.props.maxPages) {
                max = this.props.maxPages;
            }
            if (max - min < pageSpan) {
                min = max - pageSpan;
                if (min < 1) {
                    min = 1;
                }
            }
            for(let i = min; i <= max; i++){
                pageArray.push(i);
            }
        }
        return pageArray;
    }
    handlePageChange() {
        var _getNpsModule;
        focusElement(Constants.SearchBy.Id, 'pagechange_id');
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.increaseActionsCounter('paginationActionsCount');
    }
    getPageAriaLabel(page) {
        if (this.props.query && this.props.query.page === page.toString()) {
            return 'Page ' + page + ' current page';
        }
        return 'Page ' + page;
    }
    renderImpl() {
        const { galleryPage, maxPages, entityType } = this.props;
        const pageArray = this.getPageNavigationArray();
        const route = getEntityRegistration(entityType).route;
        const getPageLink = (n)=>this.context.buildHref(route, null, {
                page: n.toString()
            }, true);
        return /*#__PURE__*/ _jsx("div", {
            className: "paginationContainer",
            children: pageArray.length > 1 ? /*#__PURE__*/ _jsxs("ul", {
                className: "m-pagination",
                tabIndex: 0,
                "aria-label": this.context.loc('PAGINATION_Navigation', 'Pagination navigation'),
                children: [
                    galleryPage === 1 ? null : /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(InternalLink, {
                            className: "c-glyph paginationPrevious",
                            "aria-label": "Previous Page",
                            href: getPageLink(galleryPage - 1),
                            scrollToTop: true,
                            accEnabled: true,
                            additionalCommand: this.handlePageChange.bind(this),
                            children: this.context.loc('PAGINATION_Previous', 'Previous')
                        })
                    }),
                    pageArray.map((e, i)=>/*#__PURE__*/ _jsx("li", {
                            className: classNames({
                                'f-active': e === galleryPage
                            }),
                            children: /*#__PURE__*/ _jsx(InternalLink, {
                                href: getPageLink(e),
                                "aria-label": this.getPageAriaLabel(e),
                                scrollToTop: true,
                                accEnabled: true,
                                additionalCommand: this.handlePageChange.bind(this),
                                children: e
                            })
                        }, i)),
                    galleryPage === maxPages ? null : /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(InternalLink, {
                            className: "c-glyph paginationNext",
                            "aria-label": "Next Page",
                            href: getPageLink(galleryPage + 1),
                            accEnabled: true,
                            scrollToTop: true,
                            additionalCommand: this.handlePageChange.bind(this),
                            children: this.context.loc('PAGINATION_Next', 'Next')
                        })
                    })
                ]
            }) : null
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
export { PaginationControl as default };
PaginationControl.contextTypes = {
    buildHref: PropTypes.func,
    loc: PropTypes.func,
    renderErrorModal: PropTypes.func
};
